import React from 'react';
import TailwindSelect from "../../../components/tailwind/TailwindSelect";

export default function VariableMappingFields({
  isImportingCsvExcel,
  headerVariables,
  bodyVariables,
  buttonVariables,
  isAuthCopyCode,
  csvColumns,
  variableMapping,
  templateParams,
  handleVariableMappingChange,
  dispatch,
  setTemplateParams
}) {
  const renderCsvMappingField = (label, varName, valueKey, onChangeKey) => (
    <div key={valueKey}>
      <label className="text-gray-600 dark:text-slate-400 text-sm mb-1.5 block">
        {label} <span className="text-red-500">*</span>
      </label>
      <TailwindSelect
        placeholder="Select column..."
        items={csvColumns.map(col => ({ value: col, label: col }))}
        value={variableMapping[onChangeKey] || ""}
        onChange={(val) => handleVariableMappingChange(onChangeKey, val)}
        triggerClassName="w-full h-11 bg-gray-50 dark:bg-slate-950 border border-gray-200 dark:border-slate-800 rounded-md text-sm focus:ring-2 focus:ring-[hsl(158, 48%, 41%)] text-gray-900 dark:text-white"
      />
    </div>
  );

  const renderManualInputField = (label, varName, sectionKey, valueKey) => (
    <div key={valueKey}>
      <label className="text-gray-600 dark:text-slate-400 text-sm mb-1.5 block">
        {label} <span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        className="w-full px-3 py-2 bg-gray-50 dark:bg-slate-950 border border-gray-200 dark:border-slate-800 rounded-md text-sm focus:ring-2 focus:ring-[hsl(158, 48%, 41%)] text-gray-900 dark:text-white"
        value={sectionKey ? (templateParams[sectionKey]?.[valueKey] || '') : (templateParams[valueKey] || '')}
        onChange={(e) => {
          if (sectionKey) {
            dispatch(setTemplateParams({
              ...templateParams,
              [sectionKey]: { ...templateParams[sectionKey], [valueKey]: e.target.value }
            }));
          } else {
            dispatch(setTemplateParams({
              ...templateParams,
              [valueKey]: e.target.value
            }));
          }
        }}
      />
    </div>
  );

  if (isImportingCsvExcel) {
    return (
      <>
        {headerVariables.map((v, i) => renderCsvMappingField(`Header Variable: ${v}`, v, `header-${i}`, v))}
        {bodyVariables.map((v, i) => renderCsvMappingField(`Body Variable: ${v}`, v, `body-${i}`, v))}
        {buttonVariables.map((v, i) => renderCsvMappingField(`Button ${v.buttonIndex} URL Variable: {${v.paramIndex}}`, v.key, `button-${i}`, v.key))}
        {isAuthCopyCode && renderCsvMappingField(`Authentication Code`, 'code', 'auth-code', 'code')}
      </>
    );
  }

  return (
    <>
      {headerVariables.map((v, i) => renderManualInputField(`Header Variable: ${v}`, v, 'header', v))}
      {bodyVariables.map((v, i) => renderManualInputField(`Body Variable: ${v}`, v, 'body', v))}
      {buttonVariables.map((v, i) => renderManualInputField(`Button ${v.buttonIndex} URL Variable: {${v.paramIndex}}`, v.key, 'button', v.key))}
      {isAuthCopyCode && renderManualInputField(`Authentication Code`, 'code', null, 'code')}
    </>
  );
}
